var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  ref: "",
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择角色"
                  },
                  model: {
                    value: _vm.searchData.role_id,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "role_id", $$v)
                    },
                    expression: "searchData.role_id"
                  }
                },
                _vm._l(_vm.rolesAllList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.title, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  ref: "",
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择游戏"
                  },
                  model: {
                    value: _vm.searchData.game_mark,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "game_mark", $$v)
                    },
                    expression: "searchData.game_mark"
                  }
                },
                _vm._l(_vm.gameAllList, function(item) {
                  return _c("el-option", {
                    key: item.game_mark,
                    attrs: { label: item.game_name, value: item.game_mark }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getData(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20, type: "flex", justify: "start" } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addgainAdv.open()
                    }
                  }
                },
                [_vm._v("新增")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, border: "" } },
        [
          _c("el-table-column", {
            attrs: { prop: "role_id", label: "角色ID" }
          }),
          _c("el-table-column", {
            attrs: { prop: "role_name", label: "角色名称" }
          }),
          _c("el-table-column", {
            attrs: { prop: "game_name", label: "游戏" }
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "100",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleDelete(scope.row.id)
                            }
                          }
                        },
                        [_vm._v("删除")]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("addgainAdv", {
        ref: "addgainAdv",
        on: {
          refreshDataList: function($event) {
            return _vm.getData(_vm.searchData.page)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }